"use client"

import { motion } from "framer-motion"
import { Sparkles } from "lucide-react"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

interface ProgressIndicatorProps {
  currentCount: number
  targetCount: number
}

export function ProgressIndicator({ currentCount, targetCount }: ProgressIndicatorProps) {
  const progress = (currentCount / targetCount) * 100

  // Motivational messages based on progress
  const getMessage = () => {
    if (currentCount === 1) {
      return "Skvělý začátek! Ještě 2 záznamy a AI ti pomůže rozpoznat vzorce."
    }
    if (currentCount === 2) {
      return "Už jsi blízko! Ještě 1 záznam a uvidíš hlubší analýzu tvých vzorců."
    }
    return ""
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
    >
      <Card className="bg-gradient-to-br from-primary/5 to-secondary/5 border-primary/20">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm sm:text-base flex items-center gap-2">
            <Sparkles className="h-4 w-4 text-primary" />
            <span>Pokračuj v zaznamenávání</span>
          </CardTitle>
        </CardHeader>
        <CardContent className="pt-0 space-y-3">
          {/* Progress bar */}
          <div className="space-y-2">
            <div className="h-2 bg-muted rounded-full overflow-hidden">
              <motion.div
                className="h-full bg-gradient-to-r from-primary to-secondary rounded-full"
                initial={{ width: 0 }}
                animate={{ width: `${progress}%` }}
                transition={{
                  type: "spring",
                  stiffness: 100,
                  damping: 15,
                  duration: 0.6,
                }}
              />
            </div>
            <p className="text-xs text-center text-muted-foreground">
              {currentCount}/{targetCount} záznamů
            </p>
          </div>

          {/* Motivational message */}
          <p className="text-xs sm:text-sm text-center leading-relaxed text-pretty">
            {getMessage()}
          </p>
        </CardContent>
      </Card>
    </motion.div>
  )
}
